export { StarRating } from './rating';

export type { StarRatingProps } from './index.types';
